module.exports = __webpack_public_path__ + "images/index/img06.797165c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yartai/img06.jpg
// module id = Eo74
// module chunks = 21